import { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { InputNumber } from "primereact/inputnumber";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import { Chart as ChartJS } from "chart.js";

export function GraficoMetragemDia({ data, grupo, printing }) {
    const [datac, setDatac] = useState([]);
    const [max, setMax] = useState(0);
    const [total, setTotal] = useState(0);
    const [value, setValue] = useState(0);

    ChartJS.register(annotationPlugin);

    useEffect(() => {
        let chart = {...data};
        let total = 0;
        let maxvalue = null;
        let colors = [];

        chart.datasets[0].data.forEach((item) => {
            if(maxvalue === null) {
                maxvalue = parseFloat(item);
            } else if(maxvalue < parseFloat(item)) {
                maxvalue = parseFloat(item);
            } 

            if(item < value) {
                colors.push("#e74c3c");
            } else {
                colors.push("#2ecc71");
            }

            total += parseFloat(item);            
        });

        chart.datasets[0].backgroundColor = colors;
        
        setMax(maxvalue);
        setTotal(total);
        setDatac(chart);
    }, [data, value]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            
            {printing === false && (
                <div style={{ marginBottom: '10px' }}>
                    <InputNumber
                        className="p-m-2"
                        onChange={(e) => setValue(e.value)}
                        placeholder="Exemplo: 1500"
                        value={value}
                    />
                </div>
            )}
            
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Chart
                    className="p-m-1"
                    data={datac}
                    height="550px"
                    width="80%"
                    options={{
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: `${grupo}`,
                                font: {
                                    size: 24,
                                },
                            },
                            subtitle: {
                                display: true,
                                text: `Total - ${Intl.NumberFormat("pt-BR").format(total)}m  /  Meta: ${Intl.NumberFormat("pt-BR").format(value)}m`,
                                font: {
                                    size: 24,
                                },
                            },
                            legend: {
                                labels: {
                                    color: "#000"
                                }
                            },
                            annotation: {
                                annotations: {
                                    line1: {
                                        type: "line",
                                        yMin: value !== null ? value : 0,
                                        yMax: value !== null ? value : 0,
                                        borderColor: "#2980b9",
                                        borderWidth: 2,
                                    },
                                },
                            },
                            datalabels: {
                                labels: {
                                    label1: {
                                        anchor: "end",
                                        align: "end",
                                        rotation: -90,
                                        formatter: (label, ctx) => {
                                            if (ctx.dataset.label === "Meta") {
                                                return "";
                                            }
                                            return Intl.NumberFormat("pt-BR", {
                                                maximumFractionDigits: 2,
                                            }).format(label);
                                        },
                                        font: {
                                            size: 20
                                        },
                                        color: "#2c3e50",
                                    },
                                    label2: {
                                        anchor: "center",
                                        align: "center",
                                        formatter: (label, ctx) => {
                                            if(String(ctx.dataset.label).substring(0, 1) !== 'T') {
                                                return Intl.NumberFormat("pt-BR", {
                                                    maximumFractionDigits: 1
                                                }).format(ctx.dataset.eficiencias[ctx.dataIndex])
                                            }
                                            return ''
                                        },
                                        font: {
                                            size: 16
                                        },
                                        color: "#2c3e50"
                                    }
                                }
                            },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    font: {
                                        size: 16
                                    },
                                    color: "#000"
                                }
                            },
                            y: {
                                max: max + 9000,
                            },
                        },
                    }}
                    type="bar"
                    plugins={[ChartDataLabels, annotationPlugin]}
                />
            </div>
        </div>
    )
}